import React from "react";
import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import * as Sentry from "@sentry/react";
import { PostHogProvider, PostHogErrorBoundary } from "@posthog/react";

import "./main.css";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/charts/styles.css";

import { AuthProvider } from "./contexts/AuthContext";
import client from "./graphql/client";
import App from "./App";
import ErrorFallback from "./components/ErrorFallback";
import { theme } from "./utils/theme";
import config from "./utils/config";
import posthog from "./utils/posthog";
import "./utils/tracing";

Sentry.init({
  dsn: "https://648ab9d87287a9bccba55b50c5b66f45@o1094986.ingest.us.sentry.io/4506892823822336",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: config.ENV,
  release: config.SHA,
  enabled: config.ENV !== "local",
  ignoreErrors: ["Failed to load Stripe.js"],
  denyUrls: [/js\.stripe\.com/],
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <MantineProvider theme={theme}>
        <AuthProvider>
          <ApolloProvider client={client}>
            <ModalsProvider>
              <Notifications />
              <PostHogErrorBoundary fallback={<ErrorFallback />}>
                <App />
              </PostHogErrorBoundary>
            </ModalsProvider>
          </ApolloProvider>
        </AuthProvider>
      </MantineProvider>
    </PostHogProvider>
  </React.StrictMode>
);
